import { Grid, Typography, Button } from "@mui/material";
import { useServiceWhatsApp } from "hooks/servicioWhastApp/useWhatsApp";

export const ServicioNoActivo = () => {
  const { serviceActived, startGetGuardarNumero, setContentModal, closeModal } =
    useServiceWhatsApp();

  const cancelServicio = () => {
    startGetGuardarNumero(" ", "N");
    closeModal();
    return;
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        margin={2}
        textAlign={"start"}
        justifyContent={"center"}
      >
        <Typography variant="body1">
          Recuerda que puedes activar el servicio en cualquier momento, sólo
          tienes que entrar al apartado 'Sitios de interés' y seleccionar la
          opción 'Notificaciones via mensjería instantánea'
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        margin={2}
        display={"flex"}
      >
        <Button
          style={{ marginRight: "5px" }}
          variant="outlined"
          onClick={() =>
            setContentModal(!serviceActived ? "inicio" : "actualizarServicio")
          }
        >
          Cancelar
        </Button>
        <Button variant="contained" onClick={() => cancelServicio()}>
          Si, Estoy Seguro
        </Button>
      </Grid>
    </Grid>
  );
};
